/**
 * « Sauvegarder la recherche » form of the saved-search modal (partials/saved-search-modal-templates):
 * the submit of SavedSearch.vue and Resume.vue (saveSearchForm.post(savedSearchs.store)). The
 * validation message (title, then search_url) shows under the title input like TextInput.vue's
 * :message; on success the form modal gives way to the « Recherche sauvegardée » one.
 */
import { closeModal, openModal } from "@/shared/modal";
import { showBladeToast } from "@/shared/toast";

function csrfToken(): string {
    return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? "";
}

export function submitSavedSearch(
    modal: HTMLElement,
    form: HTMLFormElement,
    searchUrl: string,
    savedTemplate: HTMLTemplateElement,
    onClose?: () => void,
): void {
    const input = form.querySelector<HTMLInputElement>("input");
    const errorWrap = form.querySelector<HTMLElement>(".input__error")?.parentElement ?? null;
    const errorText = form.querySelector<HTMLElement>("p.input__error");
    const showError = (message: string) => {
        if (errorText) errorText.textContent = message;
        if (errorWrap) errorWrap.style.display = "";
        input?.classList.add("input__error");
    };

    void (async () => {
        try {
            const response = await fetch("/savedSearchs", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": csrfToken(),
                    Accept: "application/json",
                },
                body: JSON.stringify({ search_url: searchUrl, title: input?.value ?? "" }),
            });
            if (!response.ok) {
                const payload = (await response.json().catch(() => null)) as {
                    message?: string;
                    errors?: Record<string, string[]>;
                } | null;
                showError(
                    payload?.errors?.title?.[0] ??
                        payload?.errors?.search_url?.[0] ??
                        payload?.message ??
                        "Impossible de sauvegarder la recherche.",
                );
                return;
            }
            closeModal(modal);
            openModal(savedTemplate, onClose);
        } catch {
            showBladeToast("Impossible de sauvegarder la recherche.", "error");
        }
    })();
}
